import React, { lazy, Suspense, useState } from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

const TablaCaratulasInactivasView = lazy(() => import('./TablaCaratulasInactivasView'))
const TablaCaratulasActivasView = lazy(() => import('./TablaCaratulasActivasView'))
const TablaCaratulasFinalizadasView = lazy(() => import('./TablaCaratulasFinalizadasView'))

const renderLoader = () => <div style={{ marginLeft: '10px', width: '20%' }}><CircularProgress style={{ color: '#3f51b5' }} /></div>
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

export const TablaComunicacionesView = (props) => {
  const classes = useStyles()
  const [value, setValue] = useState('2')

  const handleChange = (event, newValue) => {
    setValue(newValue)
    props.cambiarEstadoTablas(parseInt(newValue))
    props.actualizarFiltrosExportadores()
  }
  return (
    <div className={classes.root}>
      <br />
      <TabContext value={value}>
        <AppBar position='static' color='default'>
          <TabList onChange={handleChange}
            aria-label='Comunicación de Embarque'
            indicatorColor='primary'
            textColor='primary'
            centered
          >
            <Tab label='Carátulas Inactivas' value='1' />
            <Tab label='Carátulas Activas' value='2' />
            <Tab label='Carátulas Finalizadas' value='3' />
          </TabList>
        </AppBar>
        <TabPanel value='1'>
          <Suspense fallback={renderLoader()}>
            <TablaCaratulasInactivasView />
          </Suspense>
        </TabPanel>
        <TabPanel value='2'>
          <Suspense fallback={renderLoader()}>
            <TablaCaratulasActivasView />
          </Suspense>
        </TabPanel>
        <TabPanel value='3'>
          <Suspense fallback={renderLoader()}>
            <TablaCaratulasFinalizadasView />
          </Suspense>
        </TabPanel>
      </TabContext>
      <br />
    </div>
  )
}
